export default __webpack_public_path__ + "media/images/svg/text-card-decor-8c27e2554bfc19008435651d1637367c.svg";